import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaTrashAlt } from "react-icons/fa"; // Importing icons for edit and delete
import './manageNotifications.css'
import BannerUpdate from '../../components/BannerUpdate/BannerUpadate';
import API_URL from '../../api/ExamCalendarApi';

const NotificationsManager = () => {
  const [notifications, setNotifications] = useState([]);
  const [formData, setFormData] = useState({ name: "", date: "", link: "" });
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Fetch notifications
  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${API_URL}/notification/get-notifications`);
      setNotifications(response.data);
    } catch (err) {
      setError("Error fetching notifications");
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Add or Update notification
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await axios.put(`${API_URL}/notification/update-notifications/${editingId}`, formData);
        setSuccess("Notification updated successfully");
      } else {
        await axios.post(`${API_URL}/notification/add-notification`, formData);
        setSuccess("Notification created successfully");
      }
      setFormData({ name: "", date: "", link: "" });
      setEditingId(null);
      fetchNotifications();
    } catch (err) {
      setError("Error saving notification");
    }
  };

  // Edit notification
  const handleEdit = (notification) => {
    setFormData({
      name: notification.name,
      date: notification.date.split("T")[0],
      link: notification.link,
    });
    setEditingId(notification._id);
  };

  // Delete notification
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/notification/delete-notifications/${id}`);
      setSuccess("Notification deleted successfully");
      fetchNotifications();
    } catch (err) {
      setError("Error deleting notification");
    }
  };

  return (
    <div className="admin-managenotification-container">
      <h2 className="admin-managenotification-header">Manage Notifications</h2>
      <BannerUpdate pageName="notification-centre"/>
      {error && <div className="admin-managenotification-alert admin-managenotification-alert-danger">{error}</div>}
      {success && <div className="admin-managenotification-alert admin-managenotification-alert-success">{success}</div>}

      <form onSubmit={handleSubmit} className="admin-managenotification-form">
        <div className="admin-managenotification-form-group">
          <label htmlFor="name" className="admin-managenotification-label">Notification Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="admin-managenotification-input"
            required
          />
        </div>
        <div className="admin-managenotification-form-group">
          <label htmlFor="date" className="admin-managenotification-label">Date</label>
          <input
            type="date"
            id="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            className="admin-managenotification-input"
            required
          />
        </div>
        <div className="admin-managenotification-form-group">
          <label htmlFor="link" className="admin-managenotification-label">Link</label>
          <input
            type="text"
            id="link"
            name="link"
            value={formData.link}
            onChange={handleChange}
            className="admin-managenotification-input"
            required
          />
        </div>
        <button type="submit" className="admin-managenotification-submit-btn">
          {editingId ? "Update" : "Add"} Notification
        </button>
      </form>

      <h3 className="admin-managenotification-table-header">Existing Notifications</h3>
      <div className="admin-managenotification-table-wrapper">
      <table className="admin-managenotification-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Date</th>
            <th>Link</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {notifications.map((notification) => (
            <tr key={notification._id}>
              <td>{notification.name}</td>
              <td>{new Date(notification.date).toLocaleDateString()}</td>
              <td>
                <a href={notification.link} target="_blank" rel="noopener noreferrer">
                  View Notification
                </a>
              </td>
              <td>
                <button
                  className="admin-managenotification-edit-btn"
                  onClick={() => handleEdit(notification)}
                >
                  <FaEdit />
                  Edit
                </button>
                <button
                  className="admin-managenotification-delete-btn"
                  onClick={() => handleDelete(notification._id)}
                >
                  <FaTrashAlt />
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default NotificationsManager;
